export const SCALE = {
  Desert_Main: 2000,
  Erangel_Main: 2000,
  Baltic_Main: 2000,
  Savage_Main: 1000,
  DihorOtok_Main: 1500,
  Summerland_Main: 500
};
